<template>
  <v-app>
    <!-- El menú lateral se monta aquí, una sola vez, y no dentro de cada
         página: así funciona en toda la web (home, silos, calculadoras y
         legales) sin tener que acordarse de añadirlo página a página.
         El idioma se decide por la URL: todo lo que cuelga de /cat es catalán. -->
    <component :is="menuSide"/>

    <router-view/>
    <cookie-banner/>
  </v-app>
</template>

<script>
import CookieBanner from '@/components/CookieBanner';
import MenuSideEsp from '@/components/MenuSideEsp';
import MenuSideCat from '@/components/MenuSideCat';

export default {
  name: 'App',

  computed: {
    menuSide() {
      const ruta = this.$route.path || '/';
      const esCatalan = ruta === '/cat' ||
        ruta.indexOf('/cat/') === 0 ||
        /-cat$/.test(ruta);
      return esCatalan ? MenuSideCat : MenuSideEsp;
    }
  },

  watch: {
    /* Si el usuario navega con el menú abierto, lo cerramos. */
    '$route'() {
      this.$store.commit('collapseSidebarHandler', false);
    }
  },

  components: {
    CookieBanner
  }
};
</script>
